/**
 * Banner de entrada (2026-08-23): al entrar en la app, cada persona
 * ve los pacientes que han pedido cita por correo y siguen sin atender (la
 * tarea del agente sin hacer). Se cierra con la X y no vuelve a salir en esa
 * sesión de pestaña; al día siguiente (o en otra sesión), vuelve si sigue
 * habiendo pendientes.
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { CalendarPlus, X } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function BannerSolicitudesCita() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [solicitudes, setSolicitudes] = useState(null);
  const [cerrado, setCerrado] = useState(() => sessionStorage.getItem('banner-solicitudes') === 'visto');

  useEffect(() => {
    if (!user?.id || cerrado) return;
    const rol = (user.role || '').toLowerCase();
    if (rol === 'tablet' || rol === 'tablet_consent') return;
    api.get('/api/agente/solicitudes-cita')
      .then((r) => setSolicitudes(r.data?.solicitudes || []))
      .catch(() => setSolicitudes([]));
  }, [user, cerrado]);

  if (cerrado || !solicitudes || solicitudes.length === 0) return null;

  const cerrar = () => { sessionStorage.setItem('banner-solicitudes', 'visto'); setCerrado(true); };
  const fecha = (iso) => { try { return new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }); } catch { return ''; } };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5" data-testid="banner-solicitudes">
      <div className="flex items-start gap-2.5 max-w-5xl mx-auto">
        <CalendarPlus className="w-4 h-4 text-amber-700 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0 text-sm text-amber-900">
          <button type="button" onClick={() => navigate('/mail')} className="font-semibold hover:underline text-left">
            {solicitudes.length === 1
              ? '1 paciente ha pedido cita por correo y está sin atender:'
              : `${solicitudes.length} pacientes han pedido cita por correo y están sin atender:`}
          </button>{' '}
          {solicitudes.slice(0, 4).map((s, i) => (
            <span key={s.tarea_id}>
              {i > 0 && ' · '}
              <strong>{s.nombre}</strong> ({fecha(s.fecha)})
            </span>
          ))}
          {solicitudes.length > 4 && ` · y ${solicitudes.length - 4} más`}
        </div>
        <button type="button" onClick={cerrar} className="text-amber-700 hover:text-amber-900 shrink-0 mt-0.5"
          title="Cerrar (no vuelve a salir en esta sesión)" data-testid="banner-solicitudes-cerrar">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
